import { FunctionalReducer, IReducerAction } from 'app/redux/FunctionalReducer'
import * as Redux from 'redux'

interface IUserState {
  username: string
  token: string
  accessToken: string
  isInit?: boolean
}

interface IUserAction extends IReducerAction {
  type: string
  user?: IUserState
}

const ActionTypes = {
  LOGIN: 'user/LOGIN',
  LOGOUT: 'user/LOGOUT',
  INIT: 'user/INIT',
  REGISTER: 'user/REGISTER',
  CONFIRM: 'user/CONFIRM',
}

const initialState: IUserState = {
  username: null,
  token: null,
  accessToken: null,
  isInit: false,
}

const functionalReducer = new FunctionalReducer<IUserState, IUserAction>(initialState)
  .whenTypeIs(ActionTypes.INIT, () => {
    return { username: null, token: null, accessToken: null, isInit: true }
  })
  .whenTypeIs(ActionTypes.LOGIN, (state, { user: { username, token, accessToken } }) => {
    return { username, token, accessToken, isInit: true }
  })
  .whenTypeIs(ActionTypes.LOGOUT, (state, action) => {
    return { username: null, token: null, accessToken: null, isInit: true }
  })
  .whenTypeIs(ActionTypes.REGISTER, (state) => {
    return { username: null, token: null, accessToken: null, isInit: true }
  })
  .whenTypeIs(ActionTypes.CONFIRM, (state) => {
    return { username: null, token: null, accessToken: null, isInit: true }
  })

export {
  functionalReducer,
  ActionTypes,
  IUserState,
  IUserAction
}



// WEBPACK FOOTER //
// ./src/app/redux/User/reducer/index.ts